<template>
    <v-container>
        <v-layout>
            <v-flex xs4 md3>
                <v-layout mb-3>
                    <v-flex>
                        <v-menu content-class="menu-card mt-2 app-content"
                                min-width="450px"
                                transition="scale-transition"
                                :close-on-content-click="false"
                                offset-y
                                v-model="popupFiltro">
                            <v-btn slot="activator" class="btn-default" color="dark" large outline>
                                <v-icon color="primary">lnr-funnel</v-icon>
                                <div class="pl-1">Filtrar</div>
                            </v-btn>
                            <v-layout column class="card">
                                <v-flex class="mb-4">
                                    <v-label>Login, nome</v-label>
                                    <v-text-field ref="textField" v-model="filtroTexto" flat solo hide-details
                                                maxlength="100" @keyup.enter="filtrar"></v-text-field>
                                </v-flex>
                                <v-layout row wrap justify-space-around>
                                    <v-flex v-for="(status, key) in listaStatus" :key="key" xs3>
                                        <v-btn @click.prevent="status.checked = !status.checked"
                                            :color="status.checked ? 'primary' : null"
                                            class="btn-default" outline>
                                            {{ status.text }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap justify-center>
                                    <v-flex v-for="(tipos, key) in listaTiposHierarquia" :key="key" xs5>
                                        <v-btn @click.prevent="tipos.checked = !tipos.checked"
                                               :color="tipos.checked ? 'primary' : null"
                                               class="btn-default" outline>
                                            {{ tipos.text }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout mt-3 justify-center>
                                    <v-flex xs4>
                                        <v-btn class="btn-default" color="dark" outline @click="limpar">Limpar</v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn class="btn-default primary" @click="filtrar">Filtrar</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex offset-xs7 offset-md-6 xs4 md2 align-end>
                <v-btn class="btn-default" color="primary" large @click="exportToExcel">
                    Relatório de atividades
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout column class="card table">
            <data-table ref="table" :url="url" :filter="tableFilter" :headers="headers">
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.login }}</td>
                    <td>{{ item.nome }}</td>
                    <td width="1%">
                        <v-menu full-width bottom offset-y origin="center center" transition="scale-transition">
                            <v-btn slot="activator" color="dark" class="btn-default ml-0 btn-status status-color"
                                   outline dark>
                                <v-flex text-xs-left>
                                    <span :class="getStatus(item.status).id">
                                        {{ getStatus(item.status).text }}
                                    </span>
                                </v-flex>
                            </v-btn>
                            <v-list>
                                <v-list-tile v-for="(status, key) in listaStatus.filter(s => s.id != item.status)"
                                             :key="key" @click="alterarStatus(item, status.id, status.text)">
                                    <v-list-tile-title class="select-status status-color">
                                        <span :class="status.id">
                                            {{ status.text }}
                                        </span>
                                    </v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </td>
                    <td width="1%">
                        <v-menu v-if="item.nome_hierarquia === 'supervisor'" full-width bottom offset-y origin="center center" transition="scale-transition">
                            <v-btn slot="activator" color="dark" class="btn-default distribuicao-color"
                                   outline dark>
                                <v-flex>
                                    <span :class="getDistribuicao(item.distribuicao_automatica).id">
                                        {{ getDistribuicao(item.distribuicao_automatica).text }}
                                    </span>
                                </v-flex>
                            </v-btn>
                            <v-list>
                                <v-list-tile
                                        v-for="(distribuicao_automatica, key) in listaDistribuicao.filter(s => s.id != item.distribuicao_automatica)"
                                        :key="key" @click="alterarDistribuicao(item, distribuicao_automatica.id)">
                                    <v-list-tile-title class="select-distribuicao distribuicao-color">
                                        <span :class="distribuicao_automatica.id">
                                            {{ distribuicao_automatica.text }}
                                        </span>
                                    </v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </td>
                    <td>
                        <a href="javascript:" @click="exportar(item)"><b>Exportar histórico</b></a>
                    </td>
                </template>
            </data-table>
        </v-layout>
    </v-container>
</template>

<script>
import DataTable from '../components/DataTable'
import { alert, error, sleep } from '../plugins/helpers'
import moment from 'moment'
import { Usuario } from '../constantes'

/**
   * @var item
   * @type {object}
   * @property {number} id_usuario
   * @property {string} login
   * @property {string} nome
   * @property {string} status
   */

export default {
  name: 'Usuarios',
  components: { DataTable },
  data () {
    return {
      url: '/admin/usuarios/' + Usuario.contidos_hierarquia.id + '/hierarquia',
      popupFiltro: false,
      headers: [
        { text: 'Login', value: 'login' },
        { text: 'Nome', value: 'nome' },
        { text: 'Status', value: 'status' },
        { text: 'Distribuição Automática', value: 'distribuicao_automatica' },
        { text: 'Histórico de Status', value: 'historico_status' }
      ],
      filtroTexto: '',
      listaStatus: [
        { text: Usuario.ativo.desc, color: '#85C151', checked: false, id: Usuario.ativo.id },
        { text: Usuario.inativo.desc, color: '#999999', checked: false, id: Usuario.inativo.id },
        { text: Usuario.bloqueado.desc, color: '#FF6666', checked: false, id: Usuario.bloqueado.id },
        { text: Usuario.ferias.desc, color: '#F2CC34', checked: false, id: Usuario.ferias.id }
      ],
      listaDistribuicao: [
        { text: 'Sim', checked: false, id: true },
        { text: 'Não', checked: false, id: false }
      ],
      listaTiposHierarquia: [
        { text: Usuario.contidos_hierarquia.desc, checked: true, id: Usuario.contidos_hierarquia.id },
        { text: Usuario.fora_hierarquia.desc, checked: false, id: Usuario.fora_hierarquia.id }
      ],
      tableFilter: {}
    }
  },
  computed: {
    filtro () {
      return {
        status: this.listaStatus.filter((s) => s.checked).map((s) => s.id),
        distribuicao_automatica: this.listaDistribuicao.filter((s) => s.checked).map((s) => s.id),
        'login|nome': this.filtroTexto
      }
    }
  },
  watch: {
    popupFiltro (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    }
  },
  methods: {
    getStatus (status) {
      return this.listaStatus.find((s) => s.id === status) || {}
    },
    getDistribuicao (distribuicao_automatica) {
      return this.listaDistribuicao.find((s) => s.id === distribuicao_automatica) || {}
    },
    filtrar () {
      var tipo_listagem
      var tipo_selecionado = this.listaTiposHierarquia.filter((s) => s.checked).map((s) => s.id)

      if (tipo_selecionado.length === 0) {
        alert('Selecione se os usuários filtrados estarão contidos e/ou fora da hierarquia.')
        return
      } else if (tipo_selecionado.length === 2) {
        tipo_listagem = 'todos_usuarios'
      } else {
        this.listaTiposHierarquia.forEach((s) => {
          if (s.checked === true) {
            tipo_listagem = s.id
          }
        })
      }

      this.popupFiltro = false
      this.tableFilter = { ...this.filtro }
      this.url = '/admin/usuarios/' + tipo_listagem + '/hierarquia'
    },
    exportToExcel () {
      let params = {}
      params.id_unidade_negocio = this.id_unidade_negocio
      params.filtros = this.filtro
      params.hierarquia = this.listaTiposHierarquia.filter((s) => s.checked).map((s) => s.id)

      this.$http.get('/admin/usuarios/export', {
        responseType: 'blob',
        params
      }).then((r) => {
        const url = window.URL.createObjectURL(new Blob([r.data]))
        const link = document.createElement('a')
        link.href = url
        let data = moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY')
        link.setAttribute('download', 'Relatório de atividades-' + this.$session.get('nome_unidade') + '-' + data + '.xlsx')
        document.body.appendChild(link)
        link.click()
      })
        .catch(err => {
          error(err, 'Não foi possível recuperar as informações.')
        })
    },
    limpar () {
      this.filtroTexto = ''
      this.listaStatus.forEach((s) => {
        s.checked = false
      })
      this.listaTiposHierarquia.forEach((s) => {
        if (s.id === Usuario.contidos_hierarquia.id) {
          s.checked = true
        } else {
          s.checked = false
        }
      })
      this.filtrar()
    },
    alterarStatus (item, status, status_normatizado) {
      var msg_primaria = 'Alterar o status do usuário para o status "' + status_normatizado + '"'
      var msg_secundaria = '\n\n'
      let id_usuario = this.$session.get('id_usuario')

      if (item.status === status) {
        return
      }

      if (status === Usuario.ativo.id) {
        msg_primaria += ' permitirá que o mesmo:'

        msg_secundaria += '- Mantenha sua carteira de leads cadastrados normalmente;\n' +
                          '- Continue/Volte a receber leads das distribuições automáticas. Porém, ainda podendo sofrer expiração referente aos períodos configurados de SLA.'
      } else {
        msg_primaria += ' acarretará que o mesmo:'

        if (status === Usuario.bloqueado.id || status === Usuario.ferias.id) {
          msg_secundaria += '- Mantenha sua carteira de leads cadastrados diretamente, porém, os demais leads recebidos por distribuição podem sofrer expiração referente aos períodos configurados de SLA;\n' +
                            '- Não receba mais leads das distribuições automáticas.'
        } else if (status === Usuario.inativo.id) {
          msg_secundaria += '- Perca imediatamente todos os seus leads, diretos e indiretos, durante as verificações do sistema (incluindo novos cadastros);\n' +
                            '- Não receba mais leads das distribuições automáticas.'
        }
      }

      alert({
        text: msg_primaria + msg_secundaria,
        buttons: {
          'Cancelar': () => true,
          'Confirmar': () => {
            this.$http.patch(`/admin/usuarios/${item.id_usuario}/status`, {
              'status_atual': status,
              'status_anterior': item.status,
              'id_usuario': item.id_usuario,
              'id_usuario_alterou': id_usuario
            }).then(() => {
              item.status = status
              alert('Status atualizado com sucesso!')
            }).catch((err) => {
              error(err, 'Não foi possível atualizar o status')
            })
          }
        }
      })
    },
    alterarDistribuicao (item, distribuicao_automatica) {
      if (item.distribuicao_automatica === distribuicao_automatica) {
        return
      }
      let id_unidade_negocio = this.$session.get('id_unidade_negocio')
      this.$http.patch(`/admin/usuarios/${item.id_usuario}/distribuicao`, {
        distribuicao_automatica, id_unidade_negocio
      }).then(() => {
        item.distribuicao_automatica = distribuicao_automatica
        alert('distribuição atualizada com sucesso!')
      }).catch((err) => {
        error(err, 'Não foi possível atualizar a distribuição')
      })
    },
    exportar (item) {
      let params = {}
      params.id_usuario = item.id_usuario
      params.nome_usuario = item.nome

      alert({
        text: `Deseja exportar o excel do histórico de status do usuário ${item.nome}?`,
        buttons: {
          'Não': () => true,
          'Sim': () => {
            this.$http.get('/admin/usuarios/historico/export', {
              responseType: 'blob',
              params
            }).then((r) => {
              const url = window.URL.createObjectURL(new Blob([r.data]))
              const link = document.createElement('a')
              link.href = url
              let data = moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY')
              link.setAttribute('download', 'Histórico de status-' + item.nome + '-' + data + '.xlsx')
              document.body.appendChild(link)
              link.click()
            }).catch(err => {
              error(err, 'Não foi possível recuperar as informações.')
            })
          }
        }
      })
    }
  },
  mounted () {
    this.id_unidade_negocio = this.$session.get('id_unidade_negocio')
  }
}
</script>

<style scoped>
    span.ativo:before,
    span.true:before {
        background-color: #72C151;
    }

    span.ferias:before {
        background-color: #F2CC34;
    }

    span.inativo:before {
        background-color: #999999;
    }

    span.false:before,
    span.bloqueado:before {
        background-color: #FF6666;
    }

    .btn-status {
        padding-left: 45px;
        padding-right: 35px;
    }

    .distribuicao-color span:before,
    .status-color span:before {
        border-radius: 50%;
        content: '';
        position: absolute;
        width: 12px;
        height: 12px;
        left: 0;
        top: 50%;
        margin-top: -6px;
    }

    .btn-status span:before {
        margin-left: -18px;
    }

    .select-status span,
    .select-distribuicao span {
        padding-left: 22px;
    }

    .select-status span,
    .select-distribuicao span,
    .btn-status span {
        position: relative;
    }

    .btn-status span {
        text-align: center;
        display: inline-block;
        width: 100%;
    }
</style>
